import movieArgs from "./movieArgs"

const getCheckoutQuery = ()=>{
    return `${(movieArgs.invite?'/birthday-party-invitation-maker':'/birthday-movie-maker')}/get-full-movie?uid=${movieArgs.data.uid}&mid=${movieArgs.data.mid}&email=${movieArgs.data.email}`
}
const isSolo = window.location.search.includes('uid');

const editorUtils = {getCheckoutQuery, isSolo}
export default editorUtils;